import ng from "angular";
import { AgGridService } from "@topline/services/agGridService";
import { GridOptions } from "ag-grid-community";
import { Gen } from "@topline/services/api";
import { angularServicesNames } from "@topline/services/angularServicesNames";

class ScoringCardForecastsComponentController {
    static $inject = ["$scope", angularServicesNames.$translate, AgGridService.componentName];

    public forecasts: Gen.ScoringCardReportForecastItem[] = [];
    private gridApi: $TSFixMe;
    private scoringCardName: string;

    private close: $TSFixMe;
    private dismiss: $TSFixMe;
    private resolve: $TSFixMe;

    constructor(
        private $scope: ng.IScope,
        private $translate: ng.translate.ITranslateService,
        private agGridService: AgGridService
    ) {}

    public $onInit(): void {
        this.scoringCardName = this.resolve.name;
        this.forecasts = this.resolve.forecasts;
        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));
    }

    public ok(): void {
        this.close({ $value: "ok" });
    }

    public cancel(): void {
        this.dismiss({ $value: "cancel" });
    }

    public gridOptions: GridOptions = {
        columnDefs: [
            {
                headerValueGetter: () => this.$translate.instant("SCORING_CARDS.REPORT.FORECASTS_LIST.FORECAST_NAME"),
                field: "forecastName",
                cellRenderer: params =>
                    params.data
                        ? `<div class="ui-grid-cell-contents"><a ui-sref="forecast.edit({ id : data.forecastId })" ng-click="$ctrl.cancel()">${params.value}</a></div>`
                        : ""
            },
            {
                headerValueGetter: () => this.$translate.instant("SCORING_CARDS.REPORT.FORECASTS_LIST.FORECAST_STATUS"),
                field: "forecastStatus",
                valueFormatter: params => (params.value ? this.$translate.instant(params.value) : "")
            }
        ],
        domLayout: "autoHeight",
        angularCompileRows: true,
        defaultColDef: {
            sortable: true,
            resizable: true
        },
        enableFilter: false,
        animateRows: true,
        localeTextFunc: this.agGridService.transalteFunc,
        suppressHorizontalScroll: true,
        onGridReady: (config: $TSFixMe) => {
            this.gridApi = config.api;
            config.api.sizeColumnsToFit();
            config.api.setRowData(this.forecasts);
        },
        onGridSizeChanged: (config: $TSFixMe) => {
            config.api.sizeColumnsToFit();
        }
    };
}

export class ScoringCardForecastsComponent implements ng.IComponentOptions {
    static componentName = "scoringCardForecasts";
    bindings = {
        close: "&",
        dismiss: "&",
        resolve: "<"
    };
    controller = ScoringCardForecastsComponentController;
    template = require("./scoringCardForecasts.component.html");
}

angular
    .module("topline.modules")
    .component(ScoringCardForecastsComponent.componentName, new ScoringCardForecastsComponent());
